/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MeetDayStudent } from '../../models/meet-day-student';

export interface GetMeetDayStudentForCurrentUser$Params {
  meetDayId: string;
}

export function getMeetDayStudentForCurrentUser(http: HttpClient, rootUrl: string, params: GetMeetDayStudentForCurrentUser$Params, context?: HttpContext): Observable<StrictHttpResponse<MeetDayStudent>> {
  const rb = new RequestBuilder(rootUrl, getMeetDayStudentForCurrentUser.PATH, 'get');
  if (params) {
    rb.path('meetDayId', params.meetDayId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MeetDayStudent>;
    })
  );
}

getMeetDayStudentForCurrentUser.PATH = '/meetday/{meetDayId}/student/current';
